import { Box } from "@mui/material";
import { type FC, useMemo } from "react";
import { type RequestResponsesStatus, RequestResponsesStatusOptions, type ShiftRequest } from "../../utils/models";
import { RequestData } from "./RequestData";

type ShiftDataContentProps = { request: ShiftRequest };

export const ShiftDataContent: FC<ShiftDataContentProps> = ({ request }) => {
	const requestDataItems: RequestResponsesStatus[] = useMemo(() => {
		return request.message.request_data?.filter(
			(requestData: RequestResponsesStatus) => requestData.nurse_id && requestData?.status === RequestResponsesStatusOptions.PENDING,
		);
	}, [request]);

	return (
		<>
			{requestDataItems?.length > 0 && (
				<Box sx={{ gap: 2 }}>
					{requestDataItems.map((requestData: RequestResponsesStatus) => (
						<RequestData key={requestData.nurse_id} requestData={requestData} request={request} />
					))}
				</Box>
			)}
		</>
	);
};
